import React from 'react';

class BoxItemListItem extends React.Component {
    render() {
        const {item, pos} = this.props;
        const {id, product, created} = Object.assign({}, item);
        // console.log(item)
        const {labelDetails} = product[0];
        const {partnerTrackingNumber} = Object.assign({}, labelDetails);
        const boxedAtText = created && new Date(created).toLocaleString('en-GB');
// console.log(item)
        return (
            <tr className="BoxItemListItem">
                <td>{pos}</td>
                <td className="text-primary">#{id}</td>
                <td>{partnerTrackingNumber}</td>
                <td>{boxedAtText}</td>
            </tr>
        );
    }
}

export default BoxItemListItem;
